import { ORIGIN_AND_TIME, ORIGIN_SHOP } from '@root/constant';
import { isInApp } from './terminal';
import { getQueryString } from './url';

export const setLocalReferrer = () => {
  const queryReferrer = getQueryString('from');
  if (queryReferrer === 'aidot-shop') {
    localStorage.setItem(ORIGIN_AND_TIME, `${ORIGIN_SHOP}_${Date.now()}`);
  }
};

export const getLocalReferrer = () => {
  const localOrigin = localStorage.getItem(ORIGIN_AND_TIME);
  if (localOrigin) {
    const [_origin, time] = localOrigin.split('_');
    if (time && Date.now() - +time < 3 * 24 * 60 * 60000) {
      return _origin;
    } else {
      localStorage.removeItem(ORIGIN_AND_TIME);
    }
  }
  return undefined;
};

/**
 * 订单来源 original
 * @returns 1-APP 2-商城  3-普通H5页面
 */
export const getOrderOriginal = () => {
  const localOrigin = getLocalReferrer();
  if (localOrigin === ORIGIN_SHOP) {
    return 2;
  }
  if (isInApp) {
    return 1;
  }
  return 3;
};
